<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app >
      <!-- <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn> -->
      <v-toolbar-title style="font-size:1rem;width:94%;padding-left:1.2rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">摄像机列表</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container style="padding-bottom:4.2rem;">

        <div style="margin-top:0.2rem;">
          <div v-if="loading" style="padding-top:6.5rem;">
            <LoadingText />
          </div>
          <div v-else v-for="(item,index) in list" :key="index" style="border-bottom:1px solid #eee;" >
            <DeviceCard :dev-info="item" :idx=" index + 1 " flat />
          </div>
          <ListFooter v-if="!loading" :count="list.length" />
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import DeviceCard from './DeviceCard'
import ListFooter from '../../components/ListFooter'
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    DeviceCard,
    ListFooter,
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      stat: {
        total: 0,
        online: 0,
        offline: 0
      },
      state: -1,
      loading: true
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    var that = this;
    that.initData();
  },
  activated() {
    var that = this
    that.initData()
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async getList() {
      var that = this
      that.list = []
      await that.$api.bz.queryCamDevList().then(res => {
        // console.log('queryCamDevList', res);
        if (!res.success) {
          console.log('获取摄像机列表失败', res);
          return
        }
        var data = res.data
        that.list = data
        that.loading = false
      })
    },

    changeState(val) {
      var that = this
      that.state = val
      that.initData()
    },
    async initData() {
      var that = this
      that.$store.commit('SET_FNAVVAL', 1)
      that.loading = true
      await that.getList()
      that.loading = false
    }
  }
}
</script>

<style scoped>
</style>
